import API from "Classes/Api";
import {
  ApiGetCallParams,
  ApiPostCallParams,
  ApiPutCallParams,
  ApiDeleteCallParams,
} from "Classes/ApiCallParams";

class AlertRulesService extends API {
  async getRules({ clientId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `/v2/clients/${clientId}/alerting/exception-rules`,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }

  async getRule({ clientId, ruleId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `/v2/clients/${clientId}/alerting/exception-rules/${ruleId}`,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }

  async createRule({ clientId, payload }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `/v2/clients/${clientId}/alerting/exception-rules`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        successMessage: "The Rule has been created.",
      })
    );
    return result;
  }

  async updateRule({ clientId, ruleId, payload }) {
    const result = await super.call(
      new ApiPutCallParams({
        action: `/v2/clients/${clientId}/alerting/exception-rules/${ruleId}`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
      })
    );
    return result;
  }

  async updateRuleStatus({ clientId, ruleId, payload }) {
    const result = await super.call(
      new ApiPutCallParams({
        action: `/v2/clients/${clientId}/alerting/exception-rules/${ruleId}/status`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
      })
    );
    return result;
  }

  async deleteRule({ clientId, ruleId }) {
    const result = await super.call(
      new ApiDeleteCallParams({
        action: `/v2/clients/${clientId}/alerting/exception-rules/${ruleId}`,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }
}

const instance = new AlertRulesService();
export default instance;
